import { Icon, IconProps } from "./Icon";

export function IconSilverware(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M19.5 0C15.05 0 15 14.88 15 15.51V16h4v8h1V0ZM19 15h-3c.06-4.4.85-12.72 3-13.87Zm-9-8.49A2.5 2.5 0 0 1 8 9V0H7v9a2.49 2.49 0 0 1-2-2.49V0H4v6.51A3.48 3.48 0 0 0 7 10v14h1V10a3.48 3.48 0 0 0 3-3.44V0h-1Z" />
    </Icon>
  );
}
